import { render, staticRenderFns } from "./SpecieForm.vue?vue&type=template&id=703dd63d&scoped=true&"
import script from "./SpecieForm.vue?vue&type=script&lang=js&"
export * from "./SpecieForm.vue?vue&type=script&lang=js&"
import style0 from "./SpecieForm.vue?vue&type=style&index=0&id=703dd63d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703dd63d",
  null
  
)

export default component.exports